import { Component, Input, OnInit } from '@angular/core';

import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { RateClasses } from '../../../../../../../common/js/static/RateClasses';
import {
  CPQuoteRateClassDescriptions,
  Exchange1035FundingPurpose,
} from '../../../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import type { CoverpathCustomer } from '../../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import { CommonUtils } from '../../../../../../../common/js/static/CommonUtils';
import { Utils } from '../../../../../../../common/js/Utils';
import { QuoteCardService } from '../quote-card.service';
import { Controller } from 'apps/coverpath-client/public/js/Controller';

@Component({
  moduleId: module.id,
  selector: 'quote-card-text-description',
  templateUrl: './quote-card-text-description.component.html',
})
export class QuoteCardTextDescriptionComponent implements OnInit {
  protected customer: CoverpathCustomer;
  protected controller: Controller;

  insuredFullName: string;
  insuredName: string;
  gender: string;
  isSmoker: boolean;
  dob: string;
  pronoun: string;
  fetchingIllustration: boolean;

  hasWholeLifePolicy: boolean = false;
  isJointApp: boolean = false;
  jointAppDiffHealthClasses = false;
  wholeTerm: string;
  wholeHealthTitle: string;
  healthClassDesc: string;

  termHasECP: boolean = false;
  isART: boolean = false;
  artDescription: string;
  alir1035TransferAmount: number;
  hasExchange1035TowardsPremium: boolean = false;
  isAgentSubmittedApp: boolean = false;
  cirAmount: number;
  hasRegistered: boolean = false;
  displaySupplemental: boolean = false;

  constructor(protected amorphicService: AmorphicService, protected quoteCardService: QuoteCardService) {
    this.customer = amorphicService.controller.customer as CoverpathCustomer;
    this.controller = amorphicService.controller as Controller;
  }

  ngOnInit() {
    this.controller.inviteController.getSafeInviteInfo().then((insuredInfo) => {
      const quote = insuredInfo.hasTermQuote ? insuredInfo.safeTermQuote : insuredInfo.safeWholeQuote;
      const primaryPolicy = insuredInfo.safePolicyInfo.primaryPolicy;
      this.insuredFullName = Utils.toCapitalizedWords(primaryPolicy.insured.fullName);
      this.dob = primaryPolicy.insured.dob.toLocaleDateString();
      this.gender = primaryPolicy.insured.gender === '1' ? 'male' : 'female';
      this.pronoun = primaryPolicy.insured.gender === '1' ? 'his' : 'her';
      this.isSmoker = RateClasses.findByStringCode(quote.healthClass).smoker;
      this.healthClassDesc = CPQuoteRateClassDescriptions[quote.healthClass].longDescription;
      this.isJointApp = insuredInfo.isJointApp;
      this.isAgentSubmittedApp = insuredInfo.isAgentSubmittedApp;
      this.hasRegistered = insuredInfo.hasRegistered;

      if (insuredInfo.safePolicyInfo.hasWhole) {
        const wholeLifePolicy = insuredInfo.safePolicyInfo.wholeInfo;
        this.wholeTerm = wholeLifePolicy.term.toString();
        const faceAndRtrAmount = wholeLifePolicy.hasRTR
          ? wholeLifePolicy.faceAmount + wholeLifePolicy.rtr.amount
          : wholeLifePolicy.faceAmount;
        const wholeLifeHealthClass = CommonUtils.determineRatingClass(
          quote.healthClass,
          faceAndRtrAmount,
          wholeLifePolicy.product,
          wholeLifePolicy.productType
        );
        this.wholeHealthTitle = CPQuoteRateClassDescriptions[wholeLifeHealthClass.stringCode].title;
        if (this.isJointApp) {
          this.jointAppDiffHealthClasses = wholeLifeHealthClass.stringCode !== quote.healthClass;
        }
        this.displaySupplemental = insuredInfo.safeWholeQuote.dividendInterestAdjustment > 0;

        this.hasWholeLifePolicy = insuredInfo.safePolicyInfo.hasWhole;

        if (wholeLifePolicy.hasExchange1035) {
          this.alir1035TransferAmount = wholeLifePolicy.exchange1035.cashValueTransfer;
        }
        this.hasExchange1035TowardsPremium =
          wholeLifePolicy.hasExchange1035 &&
          wholeLifePolicy.exchange1035.applyTowards === Exchange1035FundingPurpose.PREMIUM_AND_ALIR;

        if (wholeLifePolicy.hasCIR) {
          this.cirAmount = wholeLifePolicy.cir.amount;
        }
      }

      // Get Term policy info
      if (insuredInfo.safePolicyInfo.hasTerm) {
        const termInfo = insuredInfo.safePolicyInfo.termInfo;
        this.termHasECP = termInfo.hasECP;
        this.isART = termInfo.isART;
        this.artDescription = termInfo.artDescription;
      }
    });
  }

  getBasicIllustrationPdf(isSupplemental: boolean = false): void {
    this.quoteCardService.getBasicIllustrationPdf(isSupplemental);
  }
}
